(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
if (!customElements.get('ms-article-navigation')) {
  customElements.define('ms-article-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const content = this.closest('.ms-article-template')?.querySelector('.article-template__content');
      if (!content) return;
      this.initialized = true;
      const headings = Array.from(content.querySelectorAll('h2')).filter(h => h.textContent.trim() && !h.closest('[role="tabpanel"],.instagram-media'));
      const list = this.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = 'ms-article-heading-' + index;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      this.querySelector('details').hidden = headings.length < 2;
      const steps = headings.find(h => /step\s*1|step-by-step|steps to|instructions/i.test(h.textContent));
      if (steps) {
        const jump = document.createElement('a');
        jump.className = 'ms-article-jump';
        jump.href = '#' + steps.id;
        jump.textContent = this.dataset.stepsLabel;
        this.prepend(jump);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meyspring-blog-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-blog-hub')) {
  customElements.define('ms-blog-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = Array.from(this.querySelectorAll('[data-article-topics]'));
      this.buttons = Array.from(this.querySelectorAll('[data-topic]'));
      this.more = this.querySelector('.ms-blog-more');
      this.status = this.querySelector('.ms-blog-results');
      this.topic = 'all';
      this.visibleLimit = 9;
      this.onFilter = (event) => {
        const button = event.target.closest('[data-topic]');
        if (!button) return;
        this.topic = button.dataset.topic;
        this.visibleLimit = 9;
        this.update();
      };
      this.onMore = () => {
        const previousLimit = this.visibleLimit;
        this.visibleLimit += 9;
        this.update();
        const visible = this.cards.filter(card => !card.hidden);
        visible[previousLimit]?.querySelector('h3 a')?.focus();
      };
      this.querySelector('.ms-blog-topics').hidden = false;
      this.querySelector('.ms-blog-topics').addEventListener('click', this.onFilter);
      this.more.addEventListener('click', this.onMore);
      this.update();
    }
    update() {
      const matching = this.cards.filter(card => this.topic === 'all' || card.dataset.articleTopics.split(' ').includes(this.topic));
      this.cards.forEach(card => { card.hidden = true; });
      matching.slice(0, this.visibleLimit).forEach(card => { card.hidden = false; });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topic === this.topic)));
      this.querySelectorAll('[data-blog-feature],[data-blog-guides]').forEach(el => { el.hidden = this.topic !== 'all'; });
      this.more.hidden = matching.length <= this.visibleLimit;
      this.querySelector('.ms-blog-empty').hidden = matching.length > 0;
      this.status.textContent = this.dataset.resultTemplate.replace('__COUNT__', String(matching.length));
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.querySelector('.ms-blog-topics').removeEventListener('click', this.onFilter);
      this.more.removeEventListener('click', this.onMore);
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meyspring-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-resin-hero')) {
  customElements.define('ms-resin-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.initialized = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.onMotion = () => {
        this.video.autoplay = !this.motion.matches;
        if (this.motion.matches) this.video.pause();
        else this.video.play().catch(() => {});
      };
      this.onReady = () => {
        if (!this.motion.matches && !document.hidden) this.video.play().catch(() => {});
      };
      this.video.addEventListener('canplay', this.onReady);
      document.addEventListener('visibilitychange', this.onReady);
      this.motion.addEventListener('change', this.onMotion);
      this.onMotion();
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.video.pause();
      this.video.removeEventListener('canplay', this.onReady);
      document.removeEventListener('visibilitychange', this.onReady);
      this.motion.removeEventListener('change', this.onMotion);
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meyspring-product-reviews"] && !Shopify.designMode) return;
  try {
    
function meyspringReviewStatus() {
  const widget = document.getElementById('wc_review_section');
  const fallback = document.querySelector('.ms-review-unavailable');
  if (!widget || !fallback) return;
  const update = () => { fallback.hidden = !!widget.textContent.trim(); };
  window.setTimeout(update, 8000);
  new MutationObserver(() => { if (widget.textContent.trim()) fallback.hidden = true; }).observe(widget, { childList: true, subtree: true, characterData: true });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', meyspringReviewStatus, { once: true });
else meyspringReviewStatus();

  } catch(e) { console.error(e); }
})();
})();
